// @flow
export const FORGOTTEN_PASSWORD_READY = 'FORGOTTEN_PASSWORD_READY';
export const FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST = 'FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST';
export const FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT = 'FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT';
export const FORGOTTEN_PASSWORD_ERROR = 'FORGOTTEN_PASSWORD_ERROR';
export const RESET_PASSWORD_READY = 'RESET_PASSWORD_READY';
export const RESETTING_PASSWORD = 'RESETTING_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const PASSWORD_RESET_REQUEST = 'PASSWORD_RESET_REQUEST';
export const CLEAR_RESET_PASSWORD_ERROR = 'CLEAR_RESET_PASSWORD_ERROR';

export const forgottenPasswordStates = [
    FORGOTTEN_PASSWORD_READY,
    FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST,
    FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT,
    FORGOTTEN_PASSWORD_ERROR
];

export type ForgottenPasswordState = typeof forgottenPasswordStates;



// WEBPACK FOOTER //
// ./src/core/state/authentication/constants.js